var React = require('react');

function Sketch (props) {
    return React.createElement("svg",props,[React.createElement("path",{"opacity":"0.3","fillRule":"evenodd","clipRule":"evenodd","d":"M8.75 5.25H33.25L40.25 14H1.75L8.75 5.25Z","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M40.25 14L21 35L1.75 14H40.25Z","fill":"white","key":1})]);
}

Sketch.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = Sketch;

Sketch.default = Sketch;
